import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Flex,
  title: 'Flex',
  category: ComponentCategory.Layout,
  droppable: true,
};
